import React from "react";
import { Dialog } from "primereact/dialog";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { orderInspectionSelector, toggleOrderInspectionModal } from "../../features/orderInspectionSlice";
import { useTranslation } from "react-i18next";
import { labelAndValue } from "../quotation-details/LabelAndValue";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";


export default function OrderInspectionModal() {
    const {showModal, minimalInspection} = useAppSelector(orderInspectionSelector);
    const { t } = useTranslation("locale");
    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    if (!minimalInspection) {
        return <></>;
    }

    const startDateString: string = minimalInspection.startDate;
    const endDateString: string = minimalInspection.endDate;

    let startDate;
    let endDate;
    try {
        startDate = new Date(startDateString).toLocaleDateString("en-GB");

        if (endDateString) {
            endDate = new Date(endDateString).toLocaleDateString("en-GB");
        }
    } catch (error) {
        startDate = "";
        endDate = "";
    }

    const extras = minimalInspection.extras.map(ex => ex.name).join(", ");

    const orderTotal = `$${minimalInspection.orderTotal} ${minimalInspection.discountPercentage ? ` including ${minimalInspection.discountPercentage}% discount `: ""}`;

    const onContinue = () => {
        dispatch(toggleOrderInspectionModal());
        navigate("/orders");
    }

    return (
        <Dialog
            header={t("orderInspection.header")}
            visible={showModal} style={{ width: '50vw' }}
            onHide={() => null}
            closable={false}
            blockScroll
            draggable={false}
        >
            <div className="grid">
                <Message className={"col-12 mt-3 mb-2"} severity="success" text={t("orderInspection.confirmation") + minimalInspection.email} />
                {labelAndValue(t("orderInspection.orderNumber"), minimalInspection.inspectionNumber, "details-vessel-name", "order-inspection", true)}
                {labelAndValue(t("orderInspection.vessel"), `${minimalInspection.vesselName} \u2022 ${minimalInspection.imo} \u2022  ${minimalInspection.vesselType}`, "details-vessel-name", "order-inspection", false)}
                {labelAndValue(t("orderInspection.summary"),
                    `${minimalInspection.inspectionType.name} (${minimalInspection.inspectionType.shortName}) in ${minimalInspection.locationName}, ${minimalInspection.countryName} from 
                    ${startDate} ${endDate ?` to ${endDate}` : ""}`,
                    "details-vessel-name",
                    "order-inspection",
                    false
                )}
                {labelAndValue(t("orderInspection.extras"), extras.length ? extras : t("orderInspection.noExtras"), "details-vessel-name", "order-inspection", false)}
                {labelAndValue(t("orderInspection.orderTotal"), orderTotal, "details-vessel-name", "order-inspection", false)}
            </div>
            <div className={"flex justify-content-center"}>
                <Button onClick={onContinue} label={t("orderInspection.continue")} className={"mt-4 w-3"} />
            </div>

        </Dialog>
    )
}
